import React from "react";

import { NextImage } from "../NextImage";
import { Typography } from "@/components/Typography";

import { paths } from "@/utils/paths";

interface PasswordSuccessViewProps {
  successTitle: string;
  successSubtitle: string;
  successSubtitle_2?: string;
  acceptButton: string;
}

export const PasswordSuccessView = ({
  successTitle,
  successSubtitle,
  successSubtitle_2,
  acceptButton,
}: PasswordSuccessViewProps) => (
  <div className="reset_password_success_container">
    <NextImage
      src="/images/icon-alert.png"
      width={96}
      height={96}
      alt="icon alert"
      className="reset_password_success_icon"
    />
    <Typography
      Tag="p"
      classname="recover-password__title"
      size="xl"
      spacing={5}
    >
      {successTitle}
    </Typography>

    <Typography
      Tag="p"
      classname="recover-password__subtitle"
      spacing={5}
    >
      {successSubtitle}
    </Typography>

    {successSubtitle_2 && (
      <Typography
        Tag="p"
        classname="recover-password__subtitle"
        spacing={5}
      >
        {successSubtitle_2}
      </Typography>
    )}

    <button
      type="button"
      onClick={() => window.location.assign(paths.login())}
      className="button button-link success-button"
    >
      {acceptButton}
    </button>
  </div>
);
